import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ConfirmationComponent, ToastComponent } from '@web/shared/ui';
import { HttpLoadingComponent } from '@web/core';
import { isBrowserContext } from '@web/utils';
import { CookieBannerComponent } from './layouts/ui/cookie-banner/components/cookie-banner.component';

@Component({
  imports: [
    RouterModule,
    ConfirmationComponent,
    HttpLoadingComponent,
    ToastComponent,
    CookieBannerComponent,
    CookieBannerComponent,
  ],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  protected readonly isBrowserContext = isBrowserContext();
}
